import React, { useState, useContext, useMemo, useEffect } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import { StudentForm } from "./StudentForm";
import { EmployeeForm } from "./EmployeeForm";
import { TopupForm } from "./TopupForm";
import { StatementForm } from "./StatementForm";
import { WalletStudentsListTab } from "./WalletStudentsListTab";
import { WalletEmployeesListTab } from "./WalletEmployeesListTab";
import { AuthContext } from "../../contexts/Auth/AuthContext";
import { staffCanAccessWalletNfcSubtab } from "../../config/menuAccessCatalog";

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`cards-nfc-tabpanel-${index}`}
      aria-labelledby={`cards-nfc-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

const NFC_TAB_DEFS = [
  { id: "config_nfc_student_register", label: "Cadastrar Estudante", Component: StudentForm },
  { id: "config_nfc_student_list", label: "Consulta Estudantes", Component: WalletStudentsListTab },
  { id: "config_nfc_employee_register", label: "Cadastrar Colaborador", Component: EmployeeForm },
  { id: "config_nfc_employee_list", label: "Consulta Colaboradores", Component: WalletEmployeesListTab },
  { id: "config_nfc_topups", label: "Recargas", Component: TopupForm },
  { id: "config_nfc_statement", label: "Extrato", Component: StatementForm },
];

export const CardsNFCTabs = ({ initialTab = 0 }) => {
  const { user } = useContext(AuthContext);

  const visibleTabs = useMemo(
    () => NFC_TAB_DEFS.filter((t) => staffCanAccessWalletNfcSubtab(user, t.id)),
    [user]
  );

  const visibleTabIds = useMemo(() => visibleTabs.map((t) => t.id).join("|"), [visibleTabs]);

  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (!visibleTabs.length) return;
    const clamped = Math.min(Math.max(0, initialTab), visibleTabs.length - 1);
    setActiveTab(clamped);
  }, [initialTab, visibleTabIds, visibleTabs.length]);

  useEffect(() => {
    setActiveTab((prev) =>
      visibleTabs.length && prev >= visibleTabs.length ? Math.max(0, visibleTabs.length - 1) : prev
    );
  }, [visibleTabs.length]);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  if (!visibleTabs.length) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="text.secondary">
          Nenhuma sub-aba de Cartões NFC disponível para seu usuário. Peça ao administrador para ajustar as permissões
          de menu.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontSize: "14px",
              fontWeight: "600",
              minHeight: "40px",
              color: "#666",
              "&.Mui-selected": {
                color: "#1e958c",
              },
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#1e958c",
            },
          }}
        >
          {visibleTabs.map((t) => (
            <Tab key={t.id} label={t.label} />
          ))}
        </Tabs>
      </Box>

      {visibleTabs.map((t, index) => {
        const Cmp = t.Component;
        return (
          <TabPanel key={t.id} value={activeTab} index={index}>
            <Box sx={{ p: 0 }}>
              <Cmp />
            </Box>
          </TabPanel>
        );
      })}
    </Box>
  );
};
